import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import { goto } from '@wheelbox/lithejs-router';
import withTranslations from '@wheelbox/lithejs-i18n';
import { MenuIcon } from '@wheelbox/lithejs-lucide';

import { withSlice } from '@state/index';

import createId from '@utils/id';

import { APP_GLOBAL_SLICE } from '@constants/app';

import { GlobalSlice } from '@state/index.model';

import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuLink,
  Button,
} from '@components/ui';

interface NavItem {
  path: string;
  labelKey: string;
}

const navItems: NavItem[] = [
  { path: '/', labelKey: 'nav.home' },
  { path: '/tutorial', labelKey: 'nav.tutorial' },
  { path: '/docs', labelKey: 'nav.docs' },
  { path: '/examples', labelKey: 'nav.examples' },
  { path: '/blog', labelKey: 'nav.blog' },
];

const BurgerMenu: LitheFC = ({ id = createId(), testId = 'burger-menu' }) => {
  const state = withSlice<GlobalSlice>(APP_GLOBAL_SLICE);
  const t = withTranslations('Common');
  const sheetId = `${id}-sheet`;

  return Sheet(
    {
      id,
      testId,
    },
    SheetTrigger(
      {
        sheetId,
        classes: 'md:hidden',
      },
      Button(
        {
          variant: 'ghost',
          size: 'icon',
          classes: 'md:hidden',
        },
        MenuIcon({
          size: 24,
          classes: state.theme === 'dark' ? 'text-dark-text' : 'text-text',
        })
      )
    ),
    SheetContent(
      {
        sheetId,
        side: 'right',
        classes: 'w-[280px] p-0',
      },
      SheetHeader({ classes: 'p-4 border-b' }, SheetTitle({}, 'Menu')),
      [
        'nav',
        { class: 'p-4' },
        NavigationMenu(
          {
            orientation: 'vertical',
            classes: 'w-full flex-col items-start',
          },
          NavigationMenuList(
            { classes: 'flex-col items-start gap-2 w-full' },
            ...navItems.map((item) =>
              NavigationMenuItem(
                { value: item.path, classes: 'w-full' },
                NavigationMenuLink(
                  {
                    classes: 'w-full justify-start',
                    onclick: (e: MouseEvent) => {
                      e.preventDefault();
                      goto(item.path);
                      // Close sheet
                      const dialog = document.getElementById(
                        `${sheetId}-content`
                      ) as HTMLDialogElement | null;
                      dialog?.close();
                    },
                  },
                  t(item.labelKey)
                )
              )
            )
          )
        ),
      ]
    )
  ) as LitheElement<'div'>;
};

export default BurgerMenu;
